import { useContext, useEffect, useState } from 'react';
import ReactSelect from '../../../data/reactSelect';
import InputCode from '../../../data/inputCode';
import { InputDefault } from '../../../data/inputDefault';
import InputImg from '../../../data/inputImg';
import Layout from '../../../data/Layout';
import { ProdutoContext } from '../../../../context/product';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import * as S from './styled';
import ReactSelectFornecedor from '../../../data/reactSelectFornecedor';
import { IoPeopleSharp } from 'react-icons/io5';
import ModalSupplier from '../FormProduto/ModalSupplier';
import ModalPizza from '../FormProduto/ModalPizza';
import { useDispatch } from 'react-redux';
import { getConfigPizzaAsync } from '../../../../redux/features/product/services';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import Globals from '../../../../Globals.json';
import { useQueryNcmByCodeOrDes } from '../../../../apiQuery/useQueryNcmByCodeOrDes';
import { useNextIdPdv } from '../../../../apiQuery/useNextIdPdv';

interface NextIdPdvData {
  store_id: string;
  max_id_pdv: number;
  next_id_pdv: number;
}
export default function DadosGerais({
  isEdit,
  produtoEdite,
}: {
  isEdit: any;
  produtoEdite: any;
}) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['category'],
    `${Globals.api.categoriesCompleted}/minified`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  const {
    data: productTypes,
    isLoading: isLoadingProductTypes,
    isError: isErrorProductTypes,
  } = useQueryFetchPages<any>(['productTypes'], `${Globals.api.productTypes}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const {
    data: vendors,
    isLoading: isLoadingVendors,
    isError: isErrorVendors,
  } = useQueryFetchPages<any>(
    ['vendors'],
    `${Globals.api.people}/type/vendor`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  const {
    data: nextIdData,
    isLoading: isLoadingLastCode,
    isError: isErrorLastCode,
  } = useNextIdPdv(storeMe?.storeActive?.id) as {
    data: NextIdPdvData | undefined;
    isLoading: boolean;
    isError: boolean;
  };

  const {
    data: taxProfiles,
    isLoading: isLoadingTaxProfile,
    isError: isErrorTaxProfile,
  } = useQueryFetchPages<any>(['taxProfile'], `${Globals.api.taxProfile}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const [show, setShow] = useState<boolean>(false);
  const [searchNcm, setSearchNcm] = useState('');
  const { data: ncmsListNew, isLoading: isLoadingNcms } =
    useQueryNcmByCodeOrDes(searchNcm);
  const {
    status,
    setStatus,
    image,
    setImage,
    idPdv,
    setIdPdv,
    barcode,
    setBarcode,
    descriptionSale,
    setDescriptionSale,
    descriptionPurchase,
    setDescriptionPurchase,
    descriptionTouch,
    setDescriptionTouch,
    category,
    setCategory,
    setVendor,
    vendor,
    productType,
    setProductType,
    validCode,
    validDescriptionSale,
    validDescriptionPurchase,
    validDescriptionTouch,
    validCategory,
    validProductType,
    setTaxProfile,
    setStateOrigin,
    setStateDestiny,
    setTypes,
    setOrigins,
    setNcm,
    setCest,
    setCfop,

    setCustomer,

    setIcms,

    setIpi,

    setCstReasons,
    setPis,
    setWeight,
    setAliquotIcms,
    setMva,
    setReduction,
    setIcmsAliquotDeferral,
    setIcmsCredit,
    setAliquotIpi,
    setAliquotPis,
    setAliquotCofins,

    setCofins,
    setXdPrinters,
    setSelfService,
    setXdFollowItem,
    taxProfile,
    setNcm_origin,
    setVisible_falimix,
    setVisible_autoplu,
    setVisible_delivery,
    setVisible_xd_orders,
    setVisible_online,
    setVisible_digital_menu,
    setXdRequestQty,
    setXdRequestPriceWhenZero,
    setXdBalanceQty,
    setXdOrderGrouped,
    setXdBillGroup,
    setXdAddTips,
    setXdExcludeMinimumConsumption,
    setXdBook,
    setCategoriesComplement,
    setAssociatedComplement,
  } = useContext(ProdutoContext);

  const [openModalPizza, setOpenModalPizza] = useState<boolean>(false);

  function generateCode() {
    if (nextIdData && nextIdData.next_id_pdv) {
      setIdPdv(nextIdData.next_id_pdv.toString());
    } else {
      setIdPdv('1');
    }
  }

  function generateProductCode() {
    const codBar = Math.floor(Math.random() * 10000000000000);
    setBarcode(codBar.toString());
  }

  const handleOpenModalPizza = async () => {
    setOpenModalPizza(true);
    await dispatch(
      getConfigPizzaAsync(produtoEdite?.relationships?.pizza_config?.uuid)
    );
  };

  const completeTaxProfileInformationCategory = (cate: any) => {
    const categorySelected = categories?.data?.find(
      (item: any) => item.id_pdv_category === cate
    );
    const selectedTaxProfile = taxProfiles?.data?.find(
      (item: any) => item.id === categorySelected?.tax_profile_id
    );
    setIfoFiscaisPerfilFromCategory(selectedTaxProfile, categorySelected);
  };

  const setIfoFiscaisPerfilFromCategory = (list: any, category: any) => {
    console.log('list', list);
    console.log('category', category);

    setTaxProfile(list?.id ?? 0);
    setCest(list?.relationships?.cest?.id);
    setTypes(list?.relationships?.tax_invoice_type?.id);
    setOrigins(list?.relationships?.cst_origin?.id);
    setIcms(list?.relationships?.cst_icms?.id);
    setNcm(list?.relationships?.ncm?.id);
    setCfop(list?.relationships?.cfop?.id);
    setStateOrigin(list?.relationships?.icms_origin_state?.id);
    setStateDestiny(list?.relationships?.icms_destiny_state?.id);
    setCustomer(list?.relationships?.icms_customer_type?.id);
    setIpi(list?.relationships?.cst_ipi?.id);
    setCstReasons(list?.relationships?.cst_ipi_reason?.id ?? 129);
    setCofins(list?.relationships?.cst_cofins?.id);
    setPis(list?.relationships?.cst_pis?.id);
    setWeight(list?.tax_weight?.toString() ?? '0');
    setAliquotIcms(list?.icms_aliquot?.toString() ?? '0');
    setMva(list?.icms_mva?.toString() ?? '0');
    setReduction(list?.icms_base_calc_reduction?.toString() ?? '0');
    setAliquotIpi(list?.ipi_aliquot?.toString() ?? '0');
    setAliquotPis(list?.pis_aliquot?.toString() ?? '0');
    setAliquotCofins(list?.cofins_aliquot?.toString() ?? '0');
    setIcmsAliquotDeferral(list?.icms_aliquot_deferral?.toString() ?? '0');
    setIcmsCredit(list?.icms_credit?.toString() ?? '0');
    setNcm_origin(list?.ncm_origin);
    getObjectNCM(list?.relationships?.ncm?.codigo);

    setXdRequestQty(category?.xd_request_qty);
    setXdRequestPriceWhenZero(category?.xd_request_price_when_zero);
    setXdBalanceQty(category?.xd_balance_qty);
    setXdOrderGrouped(category?.xd_order_grouped);
    setXdBillGroup(category?.xd_bill_group);
    setXdAddTips(category?.xd_add_tips);
    setXdExcludeMinimumConsumption(category?.xd_exclude_minimum_consumption);
    setXdBook(category?.xd_book);
    setXdFollowItem(category?.xd_follow_item);
    setXdPrinters(category?.xd_printers);
    setSelfService(category?.self_service);
    setVisible_falimix(category?.visible_falimix);
    setVisible_autoplu(category?.visible_autoplu);
    setVisible_delivery(category?.visible_delivery);
    setVisible_xd_orders(category?.visible_xd_orders);
    setVisible_online(category?.visible_online);
    setVisible_digital_menu(category?.visible_digital_menu);
    setCategoriesComplement(category?.relationships?.complements);
    setAssociatedComplement(category?.relationships?.product_associateds);
  };

  const getObjectNCM = (codigo: string) => {
    if (codigo) {
      setSearchNcm(codigo);
    }
  };

  useEffect(() => {
    setSearchNcm('');
  }, []);
  const clearInfoFicais = () => {
    setCest(undefined);
    setTypes(undefined);
    setOrigins(undefined);
    setIcms(undefined);
    setNcm(undefined);
    setCfop(undefined);
    setStateOrigin(undefined);
    setStateDestiny(undefined);
    setCustomer(undefined);
    setIpi(undefined);
    setCstReasons(129);
    setPis(undefined);
    setCofins(undefined);
    setWeight('0');
    setAliquotIcms('0');
    setMva('0');
    setReduction('0');
    setAliquotIpi('0');
    setAliquotPis('0');
    setAliquotCofins('0');
    setIcmsAliquotDeferral('0');
    setIcmsCredit('0');
    setTaxProfile(0);
    //setXdPrinters('0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0');
    //setXdFollowItem(false);
    //setSelfService(false);
  };
  useEffect(() => {
    !isEdit && setProductType(0);
  }, []);

  useEffect(() => {
    if (isLoadingLastCode) return;
    !isEdit && generateCode();
  }, [nextIdData]);

  const bg = status ? '#16a34a' : '#f87171';
  const handleCategory = (e: any) => {
    setCategory(e?.value ?? e);
    console.log('e?.value', e?.value);

    if (e?.value ?? e) {
      completeTaxProfileInformationCategory(e?.value ?? e);
    } else {
      clearInfoFicais();
    }
  };

  useEffect(() => {
    const isInvalid = vendors?.data.find((item: any) => item.id === vendor);

    if (isInvalid) {
    } else {
      setTimeout(() => {
        setVendor(0);
      }, 200);
    }
  }, []);

  return (
    <>
      <ModalSupplier show={show} setShow={setShow} dispatch={dispatch} />
      <ModalPizza
        show={openModalPizza}
        setShow={setOpenModalPizza}
        idPdv={idPdv}
        produtoEdite={produtoEdite ?? undefined}
      />
      <Layout
        title="Dados gerais "
        check
        statusCheck={status}
        setStatusCheck={setStatus}
      >
        <S.WrapperImg>
          <button
            type="button"
            onClick={() => setStatus(!status)}
            style={{ background: bg }}
          >
            {status ? 'Ativo' : 'Inativo'}
          </button>
        </S.WrapperImg>
        <S.Content>
          <S.WrapperImg>
            <InputImg state={image} setState={setImage} />
          </S.WrapperImg>
          <S.Wrapper>
            <InputCode
              label="Código"
              type="text"
              autoComplete="off"
              state={isLoadingLastCode ? 'Carregando...' : idPdv}
              setState={setIdPdv}
              onClick={generateCode}
              isInvalid={validCode}
              disabled={isLoadingLastCode}
            />
            <InputCode
              label="Cod. Barra"
              placeholder="SKU ou EAN"
              type="text"
              autoComplete="off"
              state={barcode}
              setState={setBarcode}
              maxLength={20}
              onClick={generateProductCode}
            />
            <InputDefault
              label="Des. Compra"
              type="text"
              placeholder="Descrição de compra"
              autoComplete="off"
              state={descriptionPurchase}
              setState={setDescriptionPurchase}
              maxLength={50}
              isInvalid={validDescriptionPurchase}
            />
            <InputDefault
              label="Des. Venda"
              placeholder="Descrição de venda"
              type="text"
              autoComplete="off"
              state={descriptionSale}
              onChenge={(e: any) => {
                setDescriptionSale(e.target.value);
                setDescriptionPurchase(e.target.value);
                setDescriptionTouch(e.target.value);
              }}
              maxLength={50}
              isInvalid={validDescriptionSale}
            />
            <InputDefault
              label="Des. touch"
              placeholder="Descrição touch"
              type="text"
              autoComplete="off"
              state={descriptionTouch}
              setState={setDescriptionTouch}
              maxLength={255}
              isInvalid={validDescriptionTouch}
            />
            <ReactSelect
              label="Categoria"
              placeholder="Categoria"
              isClearable
              options={categories?.data?.map((item: any) => ({
                ...item,
                value: item.id_pdv_category,
                label: item.name,
                store_id: item.store_id,
              }))}
              state={category}
              onChange={(e: any) => handleCategory(e)}
              isInvalid={validCategory}
              isLoading={isLoadingCategories}
              isDisabled={isLoadingCategories}
            />

            <ReactSelectFornecedor
              label="Fornecedor"
              placeholder="Fornecedor"
              isClearable
              options={vendors?.data?.map((item: any) => ({
                value: item.id,
                label: item.name,
                store_id: item.store_id,
              }))}
              state={vendor}
              setState={setVendor}
              setShow={setShow}
              icon={<IoPeopleSharp />}
              isLoading={isLoadingVendors}
              isDisabled={isLoadingVendors}
            />

            <ReactSelect
              label="Tipo"
              placeholder="Tipo"
              isClearable
              options={productTypes?.data?.map((item: any) => ({
                value: item.code,
                label: item.product_type_description,
                store_id: item.store_id,
              }))}
              state={productType}
              setState={setProductType}
              isInvalid={validProductType}
              isLoading={isLoadingProductTypes}
              isDisabled={isLoadingProductTypes}
            />
            {productType === 6 && isEdit && (
              <InputDefault
                label="Configurar"
                type="button"
                state="Pizza"
                isButton
                onClick={handleOpenModalPizza}
                disabled={isLoadingProductTypes}
              />
            )}
          </S.Wrapper>
        </S.Content>
      </Layout>
    </>
  );
}
